import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { useLaunch } from '../contexts/LaunchContext';
import { StoreBadges } from './StoreBadges';
const features = ["Unlimited expenses, no daily limits", 'No ads or forced waiting', 'Unlimited kitties & members', 'Friends can join from their browser', 'Split equally or however you like', 'Receipts & receipt scanning included', 'Use different kitty currencies', 'See who owes who & settle up', 'My Balance across every kitty'];
export function Pricing() {
  const {
    isPublicLaunch
  } = useLaunch();
  const scrollToCta = () => document.getElementById('get-started')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section id="pricing" className="py-28 lg:py-36 bg-gray-50" data-id="element-246" data-mp="20sd6xb2dyij1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247" data-mp="3h6v5tqfa30hw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-248" data-mp="3h9haniasb1wf">
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-249" data-mp="4v8marcjelhj">
            {isPublicLaunch ? 'Free to download.' : 'Free during early access.'}
          </h2>
          <p className="text-lg text-gray-500 max-w-lg mx-auto" data-id="element-250" data-mp="eqk1tbvrrwqc">
            Get started free. Unlimited kitties, unlimited members, no
            subscription.
          </p>
        </motion.div>

        <div className="max-w-lg mx-auto" data-id="element-251" data-mp="3i8boqbv1tqho">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-card border border-gray-100 relative overflow-hidden" data-id="element-252" data-mp="3n7etdv749up4">
            {/* Yellow top accent line */}
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-kitty-yellow" data-id="element-253" data-mp="2rglansogvt93" />

            <div className="text-center mb-10 mt-2" data-id="element-254" data-mp="2mhrv7upmds6a">
              <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-medium mb-4" data-id="element-255" data-mp="2mh0ajexk9eus">
                <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-256" data-mp="318il2x7nih6r" />
                {isPublicLaunch ? 'No subscription' : 'Early access pricing'}
              </p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-257" data-mp="28iiqbr6v6khm">
                <span className="text-6xl md:text-7xl font-black text-kitty-dark" data-id="element-258" data-mp="23jpe023bczj1">
                  £0
                </span>
              </div>
            </div>

            <ul className="space-y-3 mb-9" data-id="element-259" data-mp="2dh3g0wohplrt">
              {features.map(feature => <li key={feature} className="flex items-center gap-3" data-id="element-260" data-mp="2dfsbgun809zn">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" data-id="element-261" data-mp="3tuaftpivtk5w">
                    <CheckIcon className="w-3.5 h-3.5 text-green-700" aria-hidden="true" data-id="element-262" data-mp="3ovqplcx99m7q" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-263" data-mp="92jix96sxv2">{feature}</span>
                </li>)}
            </ul>

            <p className="mb-7 text-center text-base font-bold text-kitty-dark" data-id="element-264" data-mp="57411dqysp4f">
              Free to download. Free to use.
            </p>

            {isPublicLaunch ? <StoreBadges tone="light" align="center" data-id="element-265" data-mp="3rhgcjiywu1tr" /> : <button onClick={scrollToCta} className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark py-4 rounded-full font-bold text-lg transition-colors duration-150 active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-dark" data-id="element-266" data-mp="j0v9sjwvg4z3">
                Join the waitlist
                <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-267" data-mp="e825ty9890o2" />
              </button>}

            {!isPublicLaunch && <p className="text-center text-xs text-gray-500 mt-5 font-medium" data-id="element-268" data-mp="11xwjuj5a8v9w">
                🚀 Limited spots, join early access now
              </p>}
          </motion.div>
        </div>
      </div>
    </section>;
}